import windowScrollTop from "syf-js-utilities/helpers/windowScrollTop";
import useEffectOnce from "syf-js-utilities/hooks/useEffectOnce";
var useScrollToTop = function () {
    useEffectOnce(function () {
        windowScrollTop();
    });
};
export default useScrollToTop;
